import { Stamps } from "../settings/DOMElements";

let ready: boolean = false;
let glInverse: boolean = false;

let leftStamp: HTMLSpanElement;
let rightStamp: HTMLSpanElement;
let upStamp: HTMLSpanElement;
let downStamp: HTMLSpanElement;

export function init(cardDOM: HTMLDivElement, inverse: boolean = false): void {

  if (!ready) {
    leftStamp = cardDOM.querySelector(Stamps.left) as HTMLSpanElement;
    rightStamp = cardDOM.querySelector(Stamps.right) as HTMLSpanElement;
    upStamp = cardDOM.querySelector(Stamps.up) as HTMLSpanElement;
    downStamp = cardDOM.querySelector(Stamps.down) as HTMLSpanElement;
    ready = true;
    glInverse = inverse;
  }

  [leftStamp, rightStamp, upStamp, downStamp].forEach((stamp) => {
    if (stamp) {
      stamp.style.transition = "none";
    }
  });

}

export function fade(x: number, y: number, verticalThreshold: number, horizontalThreshold: number): void {

  if (glInverse) {

    const percentageX = ((horizontalThreshold - x) / horizontalThreshold) * 100;

    if (rightStamp) { rightStamp.style.opacity = `${((200 - percentageX) / 100)}`; }
    if (leftStamp) { leftStamp.style.opacity = `${(percentageX / 100)}`; }

  } else {

    const percentageX = (x / horizontalThreshold) * 100;
    const percentageY = (y / verticalThreshold) * 100;

    if (rightStamp) { rightStamp.style.opacity = `${(percentageX / 100)}`; }
    if (leftStamp) { leftStamp.style.opacity = `${-(percentageX / 100)}`; }
    if (upStamp) { upStamp.style.opacity = `${-(percentageY / 100)}`; }
    if (downStamp) { downStamp.style.opacity = `${(percentageY / 100)}`; }

  }

}

export function reset(): void {

  ready = false;

  [leftStamp, rightStamp, upStamp, downStamp].forEach((stamp) => {
    if (stamp) {
      stamp.style.transition = "opacity .2s ease-out";
      if (glInverse) {
        stamp.style.opacity = "1";
      } else {
        stamp.style.opacity = "0";
      }
    }
  });

}